import { Subscription } from 'rxjs';
import { AbmWsMessage, AbmWsService } from '../services/abm-ws.service';

export abstract class HasWebSocket {
    protected funcActionMap: Map<string, string>;
    protected sender: string;
    protected wsSub: Subscription;
    protected _wsService: AbmWsService;

    protected abstract _subscribeWs(): void;
    protected abstract _unsubscribeWs(): void;
}

export function WsSender<T extends new (...args: any[]) => {}>(sender: string, actionFunctions: { actionName: string, function: string }[]) {
    return (constructor: T) => {
        const funcActionMapTemp: Map<string, string> = new Map();
        actionFunctions.forEach(af => funcActionMapTemp.set(af.function, af.actionName));
        return class extends constructor {
            sender = sender;
            funcActionMap = funcActionMapTemp;
        } as any;
    };
}

export function WsSubscribe(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function () {

        if (!this._wsService) {
            throw new Error('No _wsService injected in this class, consider extends from HasWebSocket');
        }

        this.wsSub = this._wsService.dataStream.subscribe(data => {
            const message: any = JSON.parse(data.message);

            if (data.sender === this.sender) {
                (this.funcActionMap as Map<string, string>).forEach((v, k) => {
                    if (message.hasOwnProperty(v)) {
                        this[k](message[v], false);
                    }
                });
            }
        });
        return originalMethod.apply(this, arguments);
    };

    return descriptor;
}

export function WsUnsubscribe(target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    const originalMethod = descriptor.value;

    descriptor.value = function () {
        if (this.wsSub) {
            this.wsSub.unsubscribe();
            this.wsSub = null;
        }
        return originalMethod.apply(this, arguments);
    };

    return descriptor;
}

export type WsSenderFunction = (e: any, send: boolean, ...args: any[]) => boolean;

export function WsSendFirst(target: any, propertyKey: string, descriptor: TypedPropertyDescriptor<WsSenderFunction>) {
    const msg: any = {};
    const originalMethod = descriptor.value;
    descriptor.value = function (e, send = true, ...args: any[]) {
        const actionName = this.funcActionMap.get(propertyKey);
        if (!actionName) {
            throw new Error('Can not find action name for func:' + propertyKey + ', you may need add it to @WsSender decorator.');
        }

        if (send) {
            msg[actionName] = e;
            console.log('sending', msg);
            this._wsService.send(new AbmWsMessage(this.sender, JSON.stringify(msg)));
        }

        return originalMethod.apply(this, [e, send, ...args]);
    };
    return descriptor;
}


export function WsSendLast(target: any, propertyKey: string, descriptor: TypedPropertyDescriptor<WsSenderFunction>) {
    const msg: any = {};
    const originalMethod = descriptor.value;
    descriptor.value = function (e, send = true, ...args: any[]) {
        const needSend = originalMethod.apply(this, [e, send, ...args]);

        if (!needSend || !send) {
            return needSend;
        }

        const actionName = this.funcActionMap.get(propertyKey);
        if (!actionName) {
            throw new Error('Can not find action name for func:' + propertyKey + ', you may need add it to @WsSender decorator.');
        }

        msg[actionName] = e;
        this._wsService.send(new AbmWsMessage(this.sender, JSON.stringify(msg)));

        return needSend;
    };
    return descriptor;
}
